/**
 * Copied from apps/mobile/src/features/auth/index.ts so the web client requests
 * the same grants as the other On Demand clients.
 *
 * `ctp:library-access` is the one that gates `user.libraryV2` — without it the
 * graph answers, but the library comes back empty.
 */
export const LIBRARY_SCOPES = [
  "openid",
  "profile",
  "email",
  "offline_access",
  "basic-profile",
  "ctp:library-access",
  "ctp:epub-read",
  "ctp:epub-cfi-fragments",
  "ctp:epub-shorturl",
  "ctp:annotations-read",
  "ctp:fulltext-search",
] as const

export const scopeString = (): string => LIBRARY_SCOPES.join(" ")
